/**
 * @description This file automatically loads MathJax 3.x
 * and typeset math equations currently present in DOM
 */

window.MathJax = {
  loader: { load: ['ui/safe', 'input/mml', 'input/asciimath'] },
  tex: {
    inlineMath: [
      ['$', '$'],
      ['\\(', '\\)'],
    ],
    displayMath: [
      ['$$', '$$'],
      ['\\[', '\\]'],
    ],
  },
  /** @reference https://docs.mathjax.org/en/latest/options/accessibility.html#speech-options */
  options: {
    enableAssistiveMml: true,
    enableSpeech: true, // false to disable speech strings
    enableBraille: true, // false to disable Braille notation
    // speechError: (doc, math, err) => doc.speechError(doc, math, err),  // called if speech generation fails
    sre: {
      domain: 'mathspeak', // speech rules domain
      style: 'default', // speech rules style
      locale: 'en', // the language to use (en, fr, es, de, it)
    },
    a11y: {
      speech: true, // switch on speech output when enabled
      braille: true, // switch on Braille output when enabled
    },
    worker: {
      path: 'path-to-bundle/a11y/sre', // full path to bundle/a11y/sre (set automatically)
      pool: 'speech-workerpool.html', // name of worker-pool file to load in an iframe
      worker: 'speech-worker.js', // name of worker script to load as a webworker
      debug: false, // true to include debugging messages in the browser console about
      //   the communications between the page, worker pool, and workers.
    },
  },
};

(function () {
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js';
  script.async = true;
  document.head.appendChild(script);
})();

export {};
